/**
 * The further below an enum entry is, the higher its index-z value
 *
 * @NOTE: Do not modify legacy values unless they are also modified in legacy code
 */
export enum Z_INDEXES {
  IP_POPUP_IMAGE = -1,
  CATEGORY_TREE_BACKGROUND = -1,
  ONE = 1,
  TADARIDA_HEADER_NAVIGATION_BUTTONS = 1,
  TADARIDA_HEADER_IMG_TEASER_TEXTLINE = 1,
  TADARIDA_BRANDS_HUB_HEADER_NAVIGATION_BUTTONS = 1,
  ADP_BUYBOX = 1,
  PRODUCT_TILE_CTA = 2,
  TADARIDA_FULLSCREEN_SLIDER_CLOSE_BTN = 1,
  PRODUCT_SLIDER_BADGES_CONTAINER = 2,
  TADARIDA_HEADER_IMG_TEASER_CTA = 2,
  SIZE_CHART_MODAL_HEADER = 2,
  PERSONALIZED_FILTERS_HINT = 2,
  FLYOUT_STICKY_HEADER = 2,
  APP_SCROLL_TO_TOP = 2,
  ADP_COUNTDOWN = 2,
  TOGGLE_INPUT = 3,
  ADP_BACK_BUTTON = 3,
  ADP_MWEB_COUPON_SLIDER = 4,
  APP_INSTALL_TEASER_CONTAINER = 4,
  ADD_TO_BASKET_FLYOUT_CTA_WRAPPER = 5,
  LEGACY_FLOATING_ACTION_BUTTOn = 5,
  CAMPAIGN_OVERLAY = 5,
  SUB_HEADER = 21,
  CATEGORY_TREE = 22,
  SEARCH_RESULTS_QUESTIONNAIRE = 22,
  APP_INSTALL_BANNER = 22,
  SIMPLE_BANNER = 22,
  MAIN_HEADER = 22,
  TADARIDA_FULLSCREEN_SLIDER_WRAPPER = 22,
  COUPON_LANDING_PAGE_HEADER = 23,
  SLIDE_IN_CONTAINER = 23,
  OSP_ROKT_LOADER = 99,
  FILTER_DROPDOWN = 99,
  DESKTOP_NAVIGATION_FLYOUT = 99,
  TADARIDA_HEADER_SHOP_HINT_CONTAINER = 99,
  TADARIDA_HEADER_SEARCH_OVERLAY = 99,
  DESKTOP_HEADER = 100,
  DESKTOP_HEADER_METABAR = 101,
  DISCOUNT_BANNER = 100,
  GENERIC_FLYOUT = 101,
  ADP_QUICK_VIEW_POPUP_ON_TOP_FLYOUT = 101,
  FLYOUT_FADE = 101,
  OFF_CANVAS = 101,
  HEADER_COUNTRY_SWITCH_POPUP = 101,
  NOTIFICATION_CENTER_FLYOUT = 102,
  DRAWER = 102,
  NEWSLETTER_SUBSCRIPTION_CONTENT_POPPER = 103,
  TOAST_NOTIFICATION = 300,
  MODAL_DIALOG_WRAPPER = 999,
  SUCCESS_ADD_TO_BASKET_FLYOUT_ON_WALLET = 999,
  SIZE_SELECTION_FLYOUT_ON_WALLET = 1000,
  FLYOUT_FADE_ON_DRAWER = 1000,
  COINS_HISTORY = 1000,
  COINS_CLAIM_POPUP = 1000,
  COINS_LATEST_ACHIEVEMENT = 1000,
  MOV_BASKET_FLYOUT_INFO_MODAL = 1001,
  TADARIDA_BASKET_FLYOUT = 1000,
  TADARIDA_TOAST_CONTAINER = 1000,
  SHOP_HINT = 1000,
  SUSTAINABILITY_MODAL_DIALOG = 1001,
  TADARIDA_HEADER_SEARCH_RESULTS = 999,
  TADARIDA_HEADER_ICON_META_NAVIGATION_CONTENT = 1004,
  TADARIDA_HEADER_LANGUAGE_SWITCH_POPUP = 1004,
  AVAILABLE_COUNTRY_SWITCH_BOTTOM_SHEET = 1299,
  MODAL_DIALOG_CLOSE_BUTTON = 9999,
  TO_THE_TOP = 10000,
  GRID_SYSTEM_OVERLAY = 20000,
}
